import { useEffect, useState } from 'react';
import './Toast.css';

interface ToastItem {
  id: number;
  type: 'success' | 'error' | 'info';
  message: string;
}

type Listener = (toasts: ToastItem[]) => void;

let listeners: Listener[] = [];
let items: ToastItem[] = [];
let nextId = 0;

function notify() {
  const snapshot = [...items];
  listeners.forEach(l => l(snapshot));
}

function addToast(type: ToastItem['type'], message: string, duration = 3000) {
  const id = ++nextId;
  items = [...items, { id, type, message }];
  notify();
  setTimeout(() => {
    items = items.filter(t => t.id !== id);
    notify();
  }, duration);
}

export const toast = {
  success: (message: string, duration?: number) => addToast('success', message, duration),
  error:   (message: string, duration?: number) => addToast('error',   message, duration ?? 3500),
  info:    (message: string, duration?: number) => addToast('info',    message, duration),
};

export function ToastContainer() {
  const [toasts, setToasts] = useState<ToastItem[]>([]);

  useEffect(() => {
    listeners.push(setToasts);
    return () => { listeners = listeners.filter(l => l !== setToasts); };
  }, []);

  if (toasts.length === 0) return null;

  return (
    <div className="toast-container">
      {toasts.map(t => (
        <div key={t.id} className={`toast toast--${t.type}`}>
          <span className="toast__icon">
            {t.type === 'success' ? '✓' : t.type === 'error' ? '✕' : 'i'}
          </span>
          <span className="toast__msg">{t.message}</span>
        </div>
      ))}
    </div>
  );
}
